module.exports = __webpack_public_path__ + "media/categories/structure-point-icon-eeda6441.png";